import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const banners = [
    {
        image: "/banner0.png",
        title: "Seu próximo carro está aqui",
        subtitle: "Veículos selecionados com as melhores condições",
        align: "left",
        link: "/estoque",
    },
    {
        image: "/banner1.png",
        title: "Qualidade e confiança",
        subtitle: "Compra e venda com procedência garantida",
        align: "center",
        link: "/estoque",
    },
    {
        image: "/banner2.png",
        title: "Financiamento facilitado",
        subtitle: "Aprovamos seu crédito rapidamente",
        align: "right",
        link: "/contato",
    },
];

export default function BannerCarousel() {
    return (
        <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            autoplay={{
                delay: 4500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }}
            navigation
            pagination={{ clickable: true }}
            loop
            className="w-full mt-24 md:mt-16 banner-swiper"
        >
            {banners.map((banner, index) => (
                <SwiperSlide key={index} className="relative">
                    {/* Imagem */}
                    <img
                        src={banner.image}
                        alt={banner.title}
                        className="w-full h-[55vh] md:h-[75vh] object-cover"
                    />

                    {/* Overlay elegante */}
                    <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/70" />

                    {/* Conteúdo */}
                    <div className="absolute inset-0 flex items-center">
                        <div className="container mx-auto px-6 w-full">
                            <div
                                className={`
                  banner-content
                  max-w-xl
                  ${banner.align === "left" && "text-left"}
                  ${banner.align === "center" && "text-center mx-auto"}
                  ${banner.align === "right" && "text-right ml-auto"}
                `}
                            >
                                <h2 className="text-white text-3xl md:text-5xl font-extrabold mb-4 leading-tight">
                                    {banner.title}
                                </h2>

                                <p className="text-gray-200 text-base md:text-lg mb-8">
                                    {banner.subtitle}
                                </p>

                                <Link
                                    to={banner.link}
                                    className={`
                    inline-block
                    bg-red-600 hover:bg-zinc-900
                    transition-all duration-300
                    px-7 py-3
                    rounded-full
                    text-white font-semibold
                    shadow-lg hover:shadow-xl
                    ${banner.align === "center" && "mx-auto"}
                    ${banner.align === "right" && "ml-auto"}
                  `}
                                >
                                    Ver estoque
                                </Link>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
